import React from 'react';
import ReactDOM from 'react-dom';

export const Tooltip: React.FC<{
  text: string;
  children: React.ReactNode;
  maxWidth?: number;
  block?: boolean;
}> = ({ text, children, maxWidth, block }) => {
  const [pos, setPos] = React.useState<{ x: number; y: number } | null>(null);
  return (
    <span
      style={block ? { display: 'block', width: '100%', height: '100%' } : { display: 'inline-block' }}
      onMouseEnter={(e) => setPos({ x: e.clientX, y: e.clientY })}
      onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })}
      onMouseLeave={() => setPos(null)}
    >
      {children}
      {pos && ReactDOM.createPortal(
        <span style={{
          position: 'fixed', left: pos.x + 10, top: pos.y - 32,
          background: 'rgba(0,0,0,0.75)', color: 'white',
          fontSize: '0.75rem', padding: '3px 8px', borderRadius: '4px',
          pointerEvents: 'none', zIndex: 9999,
          ...(maxWidth
            ? { whiteSpace: 'normal', maxWidth, wordBreak: 'break-word' }
            : { whiteSpace: 'nowrap' }),
        }}>
          {text}
        </span>,
        document.body
      )}
    </span>
  );
};
